import React, { memo } from "react";
import styles from "./PrivacyPolicyContainer.module.scss";

import { PageWrapper, RecomendedQuests } from "components";

const PrivacyPolicyContainer = (props: any) => {
  return (
    <>
      <PageWrapper>
        {/* <div className={'flex flex-col items-center sm:flex-shrink-1 pb-4 md:p-2 sm:p-2 min-h-screen'}> */}
        <div
          className={
            "flex flex-wrap flex-col justify-center text-textAr text-left text-base w-full mt-12 sm:px-4 mb-8 sm:mt-5"
          }
        >
          <div className="text-xl text-center sm:text-left font-bold text-pink">
            Политика конфиденциальности персональных данных
          </div>
          <br />
          <span className="text-pink text-left">1. Общие положения</span>
          1.1. Настоящая Политика конфиденциальности персональных данных (далее
          – Политика конфиденциальности) определяет порядок обработки
          персональных данных и меры по обеспечению безопасности персональных
          данных Пользователей, которые ООО "ОЛД МАУС" (далее – Администрация
          сайта) может получить при использовании Посетителями корпоративного
          сайта questminsk.by (далее – Сайта).
          <br />
          <br />
          1.2. Использование Пользователем Сайта означает согласие с настоящей
          Политикой конфиденциальности и условиями обработки персональных данных
          Пользователя.
          <br />
          <br />
          1.3. В случае несогласия с условиями Политики конфиденциальности
          Пользователь должен прекратить использование Сайта.
          <br />
          <br />
          1.4. Настоящая Политика конфиденциальности применяется только к Сайту.
          Сайт не контролирует и не несет ответственность за сайты третьих лиц,
          на которые Пользователь может перейти по ссылкам, доступным на Сайте.
          <br />
          <br />
          1.5. Администрация Сайта не проверяет достоверность персональных
          данных, предоставляемых Пользователем Сайта.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            2. Основные понятия, используемые в Политике конфиденциальности
          </span>
          «Автоматизированная обработка персональных данных» – обработка
          персональных данных с помощью средств вычислительной техники;
          «Блокирование персональных данных» – временное прекращение обработки
          персональных данных (за исключением случаев, если обработка необходима
          для уточнения персональных данных);
          <br />
          <br />
          «Сайт» – совокупность графического и информационного контента, а также
          программ для ЭВМ и баз данных, обеспечивающих их доступность в сети
          интернет по сетевому адресу questminsk.by, включая его подстраницы;
          <br />
          <br />
          «Информационная система персональных данных» — совокупность
          содержащихся в базах данных персональных данных, а также
          обеспечивающих их обработку информационных технологий и технических
          средств;
          <br />
          <br />
          «Обезличивание персональных данных» — действия, в результате которых
          невозможно определить без использования дополнительной информации
          принадлежность персональных данных конкретному Пользователю или иному
          субъекту персональных данных;
          <br />
          <br />
          «Обработка персональных данных» – любое действие (операция) или
          совокупность действий (операций), совершаемых с использованием средств
          автоматизации или без использования таких средств с персональными
          данными, включая сбор, запись, систематизацию, накопление, хранение,
          уточнение (обновление, изменение), извлечение, использование, передачу
          (распространение, предоставление, доступ), обезличивание,
          блокирование, удаление, уничтожение персональных данных;
          <br />
          <br />
          Администрация сайта – уполномоченные сотрудники по управлению сайтом,
          действующие от имени ООО "ОЛД МАУС", организующие и (или)
          осуществляющие обработку персональных данных, а также определяющие
          цели обработки персональных данных, состав персональных данных,
          подлежащих обработке, действия, совершаемые с персональными данными;
          <br />
          <br />
          «Персональные данные» – любая информация, относящаяся к
          идентифицированному Пользователю или Пользователю, который может быть
          идентифицирован на основании такой информации
          <br />
          «Пользователь» – любой посетитель сайта questminsk.by;
          <br />
          <br />
          «Предоставление персональных данных» – действия, направленные на
          раскрытие персональных данных определенному лицу или определенному
          кругу лиц;
          <br />
          <br />
          «Распространение персональных данных» – любые действия, направленные
          на раскрытие персональных данных неопределенному кругу лиц (передача
          персональных данных) или на ознакомление с персональными данными
          неограниченного круга лиц, в том числе обнародование персональных
          данных в средствах массовой информации, размещение в
          информационно-телекоммуникационных сетях или предоставление доступа к
          персональным данным каким-либо иным способом;
          <br />
          <br />
          «Трансграничная передача персональных данных» – передача персональных
          данных на территорию иностранного государства органу власти
          иностранного государства, иностранному физическому или иностранному
          юридическому лицу;
          <br />
          <br />
          «Уничтожение персональных данных» – любые действия, в результате
          которых персональные данные уничтожаются безвозвратно с невозможностью
          дальнейшего восстановления содержания персональных данных в
          информационной системе персональных данных и (или) результате которых
          уничтожаются материальные носители персональных данных. Термины,
          определения которых не указаны выше в настоящем разделе, используются
          в значении, установленном законодательством Республики Беларусь.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            3. Предмет политики конфиденциальности
          </span>
          Администрация сайта может обрабатывать следующие персональные данные
          Пользователя:
          <br />
          Фамилия, имя, отчество;
          <br />
          Электронный адрес;
          <br />
          Номер (-а) телефонов;
          <br />
          Название организации;
          <br />
          Должность.
          <br />
          <br />
          Также на сайте происходит сбор и обработка обезличенных данных о
          посетителях (в т.ч. файлов «cookie») с помощью сервисов
          интернет-статистики (Яндекс Метрика и Гугл Аналитика и других).
          Вышеперечисленные данные далее по тексту Политики объединены общим
          понятием «Персональные данные».
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            {" "}
            4. Цели обработки персональных данных
          </span>
          Цель обработки персональных данных Пользователя — уточнение деталей
          запроса/заказа; регистрация на маркетинговые мероприятия;
          информирование Пользователя посредством отправки электронных писем (в
          том числе о новых решениях и услугах, специальных предложениях и
          корпоративных событиях).
          <br />
          <br />
          Пользователь всегда может отказаться от получения информационных
          сообщений, направив Администрации сайта письмо на адрес электронной
          почты oldmouseminsk@gmail.com с пометкой «Отказ от уведомлений ООО
          "ОЛД МАУС" Обезличенные данные Пользователей, собираемые с помощью
          сервисов интернет-статистики, служат для сбора информации о действиях
          Пользователей на сайте, улучшения качества сайта и его содержания.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            5. Правовые основания обработки персональных данных
          </span>
          Администрация сайта обрабатывает персональные данные Пользователя
          только в случае их заполнения и/или отправки Пользователем
          самостоятельно через специальные формы, расположенные на сайте
          questminsk.by. Заполняя соответствующие формы и/или отправляя свои
          персональные данные Администрации сайта, Пользователь выражает свое
          согласие с данной Политикой конфиденциальности.
          <br />
          <br />
          Администрация сайта обрабатывает обезличенные данные о Пользователе в
          случае, если это разрешено в настройках браузера Пользователя
          (включено сохранение файлов «cookie» и использование технологии
          JavaScript).
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            6. Порядок сбора, хранения, передачи и других видов обработки
            персональных данных
          </span>
          Безопасность персональных данных, которые обрабатываются
          Администрацией сайта, обеспечивается путем реализации правовых,
          организационных и технических мер, необходимых для выполнения в полном
          объеме требований действующего законодательства Республики Беларусь в
          области защиты персональных данных.
          <br /> <br />
          Администрация сайта обеспечивает сохранность персональных данных и
          принимает все необходимые меры для предотвращения доступа
          неуполномоченных лиц к персональным данным Пользователя.
          <br /> <br />
          Персональные данные Пользователя никогда, ни при каких условиях не
          будут переданы третьим лицам, за исключением случаев, связанных с
          исполнением действующего законодательства. В случае выявления
          неточностей в персональных данных, Пользователь может актуализировать
          их самостоятельно, путем направления Администрации сайта уведомление
          на адрес электронной почты oldmouseminsk@gmail.com с пометкой
          «Актуализация персональных данных».
          <br /> <br />
          Срок, на который дается согласие на обработку персональных данных,
          является неограниченным. Пользователь может в любой момент отозвать
          свое согласие на обработку персональных данных, направив Администрации
          сайта уведомление посредством электронной почты на электронный адрес
          Оператора oldmouseminsk@gmail.com с пометкой «Отзыв согласия на
          обработку персональных данных».
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            7. Трансграничная передача персональных данных
          </span>
          Администрация сайта до начала осуществления трансграничной передачи
          персональных данных обязана убедиться в том, что иностранным
          государством, на территорию которого предполагается осуществлять
          передачу персональных данных, обеспечивается надежная защита прав
          субъектов персональных данных.
          <br /> <br />
          Трансграничная передача персональных данных на территории иностранных
          государств, не отвечающих вышеуказанным требованиям, может
          осуществляться только в случае наличия согласия субъекта персональных
          данных на трансграничную передачу его персональных данных и/или
          исполнения договора, стороной которого является субъект персональных
          данных.
          <br />
          <br />
          <br />
          <span className="text-pink text-left">
            8. Заключительные положения
          </span>
          Пользователь может получить любые разъяснения по интересующим
          вопросам, касающимся обработки его персональных данных, обратившись к
          Администрации сайта с помощью электронной почты
          oldmouseminsk@gmail.com.
          <br /> <br />
          В данном документе будут отражены любые изменения в обработке
          персональных данных Администрацией сайта. Политика конфиденциальности
          действует бессрочно до замены ее новой версией.
          <br /> <br />
          Актуальная версия Политики в свободном доступе расположена в сети
          Интернет по адресу questminsk.by
        </div>
        {/* </div> */}
      </PageWrapper>
      <RecomendedQuests {...props} />
    </>
  );
};

export default memo(PrivacyPolicyContainer);
